module.exports = __webpack_public_path__ + "img/mac-icon6.06e6fad.png";